import { render } from "./DashboardHome.vue?vue&type=template&id=e56d18d6"
import script from "./DashboardHome.vue?vue&type=script&lang=js"
export * from "./DashboardHome.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__